import { render, staticRenderFns } from "./GradeRangeGroupSelector.vue?vue&type=template&id=8ec7a55a&scoped=true"
import script from "./GradeRangeGroupSelector.vue?vue&type=script&lang=js"
export * from "./GradeRangeGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./GradeRangeGroupSelector.vue?vue&type=style&index=0&id=8ec7a55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec7a55a",
  null
  
)

export default component.exports